import { render } from "./ColaboradorView.vue?vue&type=template&id=7276041d"
import script from "./ColaboradorView.vue?vue&type=script&lang=js"
export * from "./ColaboradorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__